import { render, staticRenderFns } from "./auditComicInfo.vue?vue&type=template&id=b23b0d30"
import script from "./auditComicInfo.vue?vue&type=script&lang=js"
export * from "./auditComicInfo.vue?vue&type=script&lang=js"
import style0 from "./auditComicInfo.vue?vue&type=style&index=0&id=b23b0d30&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports